import * as React from 'react';
import { clsx } from 'clsx';

import styles from './ContentBlock.css';

interface IProps {
  children: React.ReactNode;
  vertical?: boolean;
  border?: boolean;
}

export const ContentBlock = (props: IProps) => {
  const { children, vertical = true, border = true } = props;

  return <div className={clsx(styles.wrapper, vertical && styles.vertical, border && styles.border)}>{children}</div>;
};
